import { c as _c } from "react/compiler-runtime";
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/libs/baseApi.client';
export interface QuizActionQuestionAnswerMutationRequest {
  id: number;
  questionId: number;
  answerId: number;
}
export interface QuizActionQuestionAnswerMutationResponse {
  success?: boolean;
  answeredCount: number;
  totalQuestions: number;
  questionResult?: {
    questionId: number;
    selectedAnswerId: number;
    correctAnswerId: number;
    isCorrect: false;
  };
}
export const useQuizActionQuestionAnswerMutation = () => {
  const $ = _c(2);
  const queryCLient = useQueryClient();
  let t0;
  if ($[0] !== queryCLient) {
    t0 = {
      mutationFn: _temp,
      onSuccess() {
        queryCLient.invalidateQueries({
          queryKey: ["user"]
        });
      }
    };
    $[0] = queryCLient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
};
async function _temp(t0) {
  const {
    id,
    ...body
  } = t0;
  const response = await api.post(`/quizzes/answer/${id}`, body);
  return response.data;
}